"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetOfferItemsPage = void 0;
var _environment = require("@ori/environment");
var _infinite = require("@ori/fetching/infinite");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _shoppingContext = require("@ori/shopping-context");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _logger = require("../logger");
var _constants = require("./constants");
var _getOfferItemsPage = require("./getOfferItemsPage");
// istanbul ignore file -- api

const PAGE_SIZE = 6;
/**
 * Hook to get paginated products data for an offer.
 * To request another page of data `loadMore` function needs to be called.
 */
const useGetOfferItemsPage = ({
  offerId,
  searchTerm
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const staticApiClient = (0, _staticApiClientReact.useApiClient)();
  const {
    atpClusterId,
    customerTypeId,
    visitorSegment,
    loading: isLoadingSegmentationParameters
  } = (0, _presentationHttp.useUserSegmentationData)();
  const sessionId = (0, _shoppingContext.useSessionId)();
  const enabled = !isLoadingSegmentationParameters && !!sessionId;
  const {
    isValidating,
    data = [],
    setSize
  } = (0, _infinite.useSWRInfinite)((pageIndex, previousPageData) => {
    const newTotalRecords = previousPageData?.totalRecords ?? 0;
    const newLoadedRecords = pageIndex * PAGE_SIZE;
    if (!enabled) {
      return null;
    }
    if (newLoadedRecords >= newTotalRecords && pageIndex > 0) {
      return null;
    }
    return {
      globalApiClient,
      lang: language,
      offerId,
      sessionId,
      staticApiClient,
      tenant,
      atpClusterId: atpClusterId ?? undefined,
      customerTypeId: customerTypeId ?? undefined,
      requestParams: {
        skip: pageIndex * PAGE_SIZE,
        top: PAGE_SIZE,
        searchTerm
      },
      visitorSegment: visitorSegment ?? undefined
    };
  }, _getOfferItemsPage.getOfferItemsPage, {
    revalidateFirstPage: false,
    onSuccess: () => {
      (0, _logger.logDebug)('useGetOfferItemsPage() hook finished successfully for offerId', offerId);
    },
    ...(0, _constants.getRetryErrorSwrOptions)()
  });
  const loading = isLoadingSegmentationParameters || isValidating;
  const offerItems = (0, _react.useMemo)(() => data.flatMap(page => page.offerItems), [data]);
  const loadedRecords = offerItems.length;
  const totalRecords = data[0]?.totalRecords ?? 0;
  const loadMoreEnabled = loadedRecords < totalRecords;

  // request another page of data
  const loadMore = (0, _react.useCallback)(() => {
    void setSize(size => size + 1);
  }, [setSize]);
  return (0, _react.useMemo)(() => ({
    loading,
    loadMoreEnabled,
    offerItems,
    totalRecords,
    loadMore
  }), [loadMore, loadMoreEnabled, loading, offerItems, totalRecords]);
};
exports.useGetOfferItemsPage = useGetOfferItemsPage;